export default __webpack_public_path__ + "static/niepolomice-image2-3795bd12731c328a970087ff6a95de04.jpg";